<core-compile-html [text]="content" [jsData]="jsData" (created)="componentCreated($event)" />
